"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var style = __importStar(require("./InputBase.style"));
var form_control_1 = require("@prezzee/form-control");
var utils_1 = require("@prezzee/utils");
var InputBase = (0, react_1.forwardRef)(function (_a, ref) {
    var ariaDescribedby = _a["aria-describedby"], autoComplete = _a.autoComplete, autoFocus = _a.autoFocus, className = _a.className, defaultValue = _a.defaultValue, disabled = _a.disabled, error = _a.error, _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b, id = _a.id, _c = _a.inputComponent, inputComponent = _c === void 0 ? 'input' : _c, _d = _a.inputProps, inputPropsProp = _d === void 0 ? {} : _d, inputRefProp = _a.inputRef, maxRows = _a.maxRows, minRows = _a.minRows, _e = _a.multiline, multiline = _e === void 0 ? false : _e, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, onClick = _a.onClick, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, placeholder = _a.placeholder, readOnly = _a.readOnly, renderSuffix = _a.renderSuffix, required = _a.required, rows = _a.rows, startAdornment = _a.startAdornment, endAdornment = _a.endAdornment, styles = _a.styles, _f = _a.type, type = _f === void 0 ? 'text' : _f, valueProp = _a.value, rest = __rest(_a, ['aria-describedby', "autoComplete", "autoFocus", "className", "defaultValue", "disabled", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "required", "rows", "startAdornment", "endAdornment", "styles", "type", "value"]);
    var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    var isControlled = (0, react_1.useRef)(value != null).current;
    var inputRef = (0, react_1.useRef)();
    var handleInputRef = (0, utils_1.useForkRef)(inputRef, inputRefProp);
    var formControl = (0, form_control_1.useFormControl)();
    var _g = __read((0, react_1.useState)(false), 2), focused = _g[0], setFocused = _g[1];
    formControl.focused = formControl ? formControl.focused : focused;
    (0, react_1.useEffect)(function () {
        if (!formControl && disabled && focused) {
            setFocused(false);
            if (onBlur) {
                onBlur(null);
            }
        }
    }, [formControl, disabled, focused, onBlur]);
    var onFilled = formControl && formControl.onFilled;
    var onEmpty = formControl && formControl.onEmpty;
    var checkDirty = (0, react_1.useCallback)(function (obj) {
        if ((0, utils_1.isFilled)(obj)) {
            if (onFilled)
                onFilled();
        }
        else if (onEmpty) {
            onEmpty();
        }
    }, [onFilled, onEmpty]);
    var handleBlur = function (event) {
        if (onBlur)
            onBlur(event);
        if (formControl && formControl.onBlur) {
            formControl.onBlur();
        }
        else {
            setFocused(false);
        }
    };
    var handleFocus = function (event) {
        if (onFocus)
            onFocus(event);
        if (formControl && formControl.onFocus) {
            formControl.onFocus();
        }
        else {
            setFocused(true);
        }
    };
    var handleChange = function (event) {
        if (!isControlled) {
            var element = event.target;
            if (element == null) {
                throw new Error('Expected valid input target');
            }
            checkDirty({
                value: element.value,
            });
        }
        if (onChange)
            onChange(event);
    };
    var handleClick = function (event) {
        if (onClick)
            onClick(event);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    (0, react_1.useEffect)(function () {
        checkDirty(inputRef.current);
    }, [valueProp]);
    var InputComponent = inputComponent;
    var inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) {
            if (process.env.NODE_ENV !== 'production') {
                if (minRows || maxRows) {
                    console.warn('You can not use the `minRows` or `maxRows` props when the input `rows` prop is set.');
                }
            }
            inputProps = __assign({ type: undefined, minRows: rows, maxRows: rows }, inputProps);
        }
        else {
            inputProps = __assign({ type: undefined, maxRows: maxRows, minRows: minRows }, inputProps);
        }
        InputComponent = 'textarea';
    }
    var rootStyles = [style.root, (styles === null || styles === void 0 ? void 0 : styles.root) && (styles === null || styles === void 0 ? void 0 : styles.root)];
    var inputStyles = [
        style.input((formControl === null || formControl === void 0 ? void 0 : formControl.focused) && !(formControl === null || formControl === void 0 ? void 0 : formControl.filled)),
        (styles === null || styles === void 0 ? void 0 : styles.input) && (styles === null || styles === void 0 ? void 0 : styles.input),
    ];
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ onClick: handleClick, className: className, ref: ref, css: rootStyles }, rest, { children: [startAdornment, (0, jsx_runtime_1.jsx)(InputComponent, __assign({ css: inputStyles, "aria-invalid": !!error, "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, defaultValue: defaultValue, disabled: disabled, id: id, name: name, placeholder: placeholder, readOnly: readOnly, required: required, rows: rows, value: value, onKeyDown: onKeyDown, onKeyUp: onKeyUp, type: type }, inputProps, { ref: handleInputRef, onBlur: handleBlur, onChange: handleChange, onFocus: handleFocus })), endAdornment, renderSuffix ? renderSuffix(__assign({}, formControl)) : null] })));
});
InputBase.displayName = 'PrezzeeInputBase';
exports.default = InputBase;
//# sourceMappingURL=InputBase.js.map